module.exports = __webpack_public_path__ + "static/media/background_4.e43ffdf2.png";